import React from 'react';
import SortableTableHeader from 'components/pure/sortable-tables/SortableTableHeader';
import classnames from 'classnames';
import TableHeaderSkill from './TableHeaderSkill';
import CogIcon from 'components/pure/utils/icon/CogIcon';
import {Popover} from 'material-ui/Popover';
import {RadioButton} from 'material-ui/RadioButton';
import {SKILLS_ORDER_OPTIONS} from 'components/manager-dashboard/strengths-and-weaknesses/SKILLS_ORDER_OPTIONS';

class TableHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.barsClick = this.barsClick.bind(this);
    this.toggleSkillsPopover = this.toggleSkillsPopover.bind(this);
    this.onSkillsOrderChange = this.onSkillsOrderChange.bind(this);

    this.state = {
      skillsOpen: false,
    };
  }

  barsClick(e, skill) {
    e.stopPropagation();
    e.preventDefault();
    if (this.props.headerTooltip) {
      this.props.headerTooltip(skill);
    }
  }

  toggleSkillsPopover() {
    this.setState({
      skillsOpen: !this.state.skillsOpen,
    });
  }

  onSkillsOrderChange(selected) {
    this.setState(
      {
        skillsOpen: false,
      },
      () => {
        this.props.skillsOrderChange(selected);
      }
    );
  }

  render() {
    const {
      skillsOrder,
      label,
      sortDirection,
      sortColumn,
      hoverIndex,
      skillsOrderSelected,
      startDate,
      endDate,
    } = this.props;

    const questionsColumnHeaders = skillsOrder.map((skill, i) => (
      <TableHeaderSkill
        startDate={startDate}
        endDate={endDate}
        skill={skill}
        sortDirection={sortDirection}
        sortColumn={sortColumn}
        label={skill}
        renderColumn={skill}
        chartTitle={`Score Trend for Skill: '${skill}'`}
        className={classnames('summary-stat', hoverIndex === i ? 'hovered' : null)}
        onClick={() => this.props.headerClick(skill)}
        key={skill}
        onMouseEnter={() => this.props.updateHoverIndex(i)}
        onMouseLeave={() => this.props.updateHoverIndex(null)}
        headerTooltip={this.props.headerTooltip}
      />
    ));
    return (
      <thead>
        <tr>
          <th className="rep-name-header freeze-left" key={label}>
            <SortableTableHeader
              label={label}
              renderColumn="rep-name"
              sortColumn={sortColumn}
              onClick={() => this.props.headerClick('rep-name')}
              sortDirection={sortDirection}
            />
          </th>
          {questionsColumnHeaders}
          <TableHeaderSkill
            startDate={startDate}
            endDate={endDate}
            skill={null}
            sortDirection={sortDirection}
            sortColumn={sortColumn}
            label={'Avg Score'}
            renderColumn="average-score"
            chartTitle="Score Trend Average"
            className={classnames(
              'score-avg',
              'freeze-right',
              hoverIndex === -1 ? 'hovered' : null
            )}
            onClick={() => this.props.headerClick('average-score')}
            onMouseEnter={() => this.props.updateHoverIndex(-1)}
            onMouseLeave={() => this.props.updateHoverIndex(null)}
            headerTooltip={this.props.headerTooltip}
            key="AVERAGE SCORE"
          />
          <th className="total freeze-right" key="Based on # of scores">
            <SortableTableHeader
              label="Based on # of scores"
              renderColumn="scorecard-count"
              sortColumn={sortColumn}
              onClick={() => this.props.headerClick('scorecard-count')}
              sortDirection={sortDirection}
            />
            <div
              className={classnames('cog', this.state.skillsOpen ? 'opened' : '')}
              ref={ref => (this.skillsToggle = ref)}>
              <CogIcon onClick={this.toggleSkillsPopover} />
            </div>
            {this.state.skillsOpen && (
              <Popover
                className="saw-popover skills"
                open={true}
                useLayerForClickAway={false}
                anchorEl={this.skillsToggle}
                canAutoPosition={false}
                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                <div className="skills-options">
                  <div className="radio-wrapper">
                    <RadioButton
                      label={SKILLS_ORDER_OPTIONS.by_count.label}
                      checked={skillsOrderSelected === SKILLS_ORDER_OPTIONS.by_count.value}
                      onClick={() => this.onSkillsOrderChange(SKILLS_ORDER_OPTIONS.by_count.value)}
                    />
                    <RadioButton
                      label={SKILLS_ORDER_OPTIONS.by_name.label}
                      checked={skillsOrderSelected === SKILLS_ORDER_OPTIONS.by_name.value}
                      onClick={() => this.onSkillsOrderChange(SKILLS_ORDER_OPTIONS.by_name.value)}
                    />
                  </div>
                </div>
              </Popover>
            )}
          </th>
        </tr>
      </thead>
    );
  }
}

TableHeader.displayName = 'SAW-TableHeader';
export default TableHeader;
